import { useState } from "react";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";

import "../Assets/css/Style.css";

function AnnualReport() {
  const [open, setOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const handleOpen = (url) => {
    setPdfUrl(url);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPdfUrl("");
  };

  const getPdfSrc = (url) => {
    if (!url) return "";
    return url.includes("#")
      ? `${url}&toolbar=0&navpanes=0&scrollbar=0`
      : `${url}#toolbar=0&navpanes=0&scrollbar=0`;
  };

  return (
    <>
      <Header />
      <Breadcrumb title="Annual Report" tabName="Annual Report" />

      <div className="innerPage annual_report">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <p className="magazine_blk_p">Annual Report PDF</p>

              <div className="magazine_blk new_magazine">
                <div
                  role="button"
                  tabIndex={0}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpen("https://example.com/sample.pdf")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleOpen("https://example.com/sample.pdf");
                    }
                  }}
                >
                  <img
                    src="https://webapi.entab.info/api/image/NCSR/public/Images/about.png"
                    className="magazine-block img-fluid"
                    alt="Magazine"
                  />
                  <button
                    type="button"
                    className="mt-4"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation(); // prevents double triggering
                      handleOpen("https://example.com/sample.pdf");
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PDF MODAL (inside annual_report for CSS specificity) */}
        {open && (
          <div
            className="annual_report_pdf-modal-backdrop"
            role="dialog"
            aria-modal="true"
            onClick={handleClose} // click outside closes
          >
            <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
              <button type="button" className="annual_report_close-btn" onClick={handleClose}>
                ✕
              </button>

              <iframe
                src={getPdfSrc(pdfUrl)}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="PDF Viewer"
              />
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}

export default AnnualReport;